import resetPIN from './resetpin';
import resetProfile from './resetprofile';

export default {
  resetPIN,
  resetProfile,
};



// WEBPACK FOOTER //
// ./src/app/services/profile/index.js